import React, { ImgHTMLAttributes, memo } from 'react';

import { useTQConnectConfig } from '../../../hooks/queries/tqConnectQueries';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  size?: number;
}

const TQConnectIcon: React.FC<Props> = ({ size = 24, ...props }) => {
  const { data } = useTQConnectConfig();

  return (
    <img
      className="tq-connect-icon"
      src={data?.tqConnectConfig?.scoreConfig?.logo}
      alt="TQ"
      width={size}
      height={size}
      {...props}
    />
  );
};

export default memo(TQConnectIcon);
